import { Box, Button, Container, Group, Stack, Text, Title } from "@mantine/core";
import { useAuth } from "@clerk/tanstack-react-start";
import { IconCircleCheck } from "@tabler/icons-react";
import { trackLandingCtaClicked } from "../utils/landing-analytics";
import classes from "./LandingHero.module.css";
import { Route } from "@/routes/__root";
import { usePostHog } from "@/lib/posthog";

export function LandingHero() {
  const navigate = Route.useNavigate();
  const { isSignedIn, isLoaded } = useAuth();
  const posthog = usePostHog();

  const handlePrimaryCTA = () => {
    const destination = isLoaded && isSignedIn ? "dashboard" : "diy_index";
    trackLandingCtaClicked(posthog, {
      placement: "hero_primary",
      destination,
    });
    if (isSignedIn) {
      navigate({ to: '/dashboard' });
    } else {
      navigate({ to: '/diy' });
    }
  };

  const primaryLabel = isLoaded && isSignedIn ? "Go to my projects" : "Plan my first project — free";

  return (
    <Box component="section" className={classes.hero}>
      <Container size="lg" className={classes.content} style={{ width: "100%", maxWidth: "100%" }}>
        <Stack gap="xl" align="center" style={{ width: "100%", maxWidth: "100%" }}>
          <Title
            order={1}
            className={classes.title}
            c="gray.0"
            ta="center"
          >
            Better home. Lower bills. Less stress.
          </Title>

          <Text
            size="xl"
            className={classes.description}
            c="gray.0"
            ta="center"
            maw={700}
            fw={400}
            style={{ maxWidth: "100%" }}
          >
            Anchor guides you through DIY projects, keeps your maintenance on track, and alerts you before small problems become expensive ones.
          </Text>

          <Text size="md" c="gray.0" ta="center" fw={300} opacity={0.95}>
            No account needed to start. Pick a project and see your custom plan in 60 seconds.
          </Text>

          <Group gap="md" mt="md">
            <Button
              size="xl"
              variant="white"
              className={classes.heroButton}
              onClick={handlePrimaryCTA}
            >
              {primaryLabel}
            </Button>
            {(!isLoaded || !isSignedIn) && (
              <Button
                size="lg"
                variant="outline"
                color="gray.0"
                onClick={() => {
                  trackLandingCtaClicked(posthog, {
                    placement: "hero_sign_in",
                    destination: "sign_in",
                  });
                  navigate({ to: '/sign-in', search: { redirect_url: '' } });
                }}
              >
                Sign In
              </Button>
            )}
          </Group>

          <Group gap="xl" mt="md" className={classes.actionGroup}>
            <Group gap="xs">
              <IconCircleCheck size={20} style={{ color: "var(--mantine-color-gray-0)" }} />
              <Text size="sm" c="gray.0" fw={500}>
                Free personalized plans
              </Text>
            </Group>
            <Group gap="xs">
              <IconCircleCheck size={20} style={{ color: "var(--mantine-color-gray-0)" }} />
              <Text size="sm" c="gray.0" fw={500}>
                No signup required
              </Text>
            </Group>
            <Group gap="xs">
              <IconCircleCheck size={20} style={{ color: "var(--mantine-color-gray-0)" }} />
              <Text size="sm" c="gray.0" fw={500}>
                Maintenance tracking included
              </Text>
            </Group>
          </Group>
        </Stack>
      </Container>
    </Box>
  );
}

export default LandingHero;
